
import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import emailjs from "@emailjs/browser";
import DOMPurify from "dompurify";
import "./Blogs.css";

const SingleBlog = () => {
  const { slug } = useParams();
  const [blog, setBlog] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const currentPageURL = window.location.href;

  // ⭐ decode HTML from API
  const decodeHTML = (html) => {
    const txt = document.createElement("textarea");
    txt.innerHTML = html;
    return txt.value;
  };

  useEffect(() => {
    const fetchBlog = async () => {
      try {
        const response = await fetch(
          "https://blog.dxbhost.agency/api/public/blogs",
          {
            headers: {
              Authorization: "Bearer cb443e4d-a7ae-42c7-b6f6-5d2f651400c9",
            },
          }
        );

        if (!response.ok) throw new Error("Failed to fetch blog");

        const data = await response.json();
        const blogs = data.blogs || [];

        const found = blogs.find((b) => b.slug === slug);

        if (!found) throw new Error("Blog not found");

        setBlog(found);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchBlog();
  }, [slug]);

  if (loading) return <div className="loading">Loading...</div>;
  if (error) return <div className="error">Error: {error}</div>;
  if (!blog) return <div className="error">Blog not found</div>;

  const imageUrl = blog.featuredImage?.url || "/images/no-image.jpg";

  // ------------------- EMAILJS SUBMIT ------------------- //
  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_cpt4lma",
        "template_5vul956",
        e.target,
        "j4EGLGyRS8i7xYNdo"
      )
      .then(
        () => alert("Message Sent Successfully!"),
        (error) => {
          alert("Failed to send message!");
          console.log(error);
        }
      );

    e.target.reset();
  };

  return (
    <div className="single-blog-container">
      <div className="single-blog-wrapper">

        {/* LEFT CONTENT */}
        <div className="single-blog-left">
          
          <h1 className="single-blog-title">{blog.title}</h1>

          <p className="single-blog-date">
            {new Date(blog.createdAt).toLocaleDateString("en-IN", {
              day: "numeric",
              month: "long",
              year: "numeric",
            })}
          </p>

          <div className="single-blog-image">
            <img src={imageUrl} alt={blog.title} />
          </div>

          {/* SAFE HTML CONTENT WITH ALLOWED TAGS */}
          <div
            className="single-blog-content"
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(
                decodeHTML(blog.content || ""),
                {
                  ALLOWED_TAGS: [
                    "h1","h2","h3","h4","h5","h6",
                    "p","br","b","strong","i","em","u","s","strike",
                    "ul","ol","li",
                    "a","img",
                    "blockquote","code","pre",
                    "div","span","hr",
                    "table","thead","tbody","tr","td","th",
                    "sub","sup","small"
                  ],
                  ALLOWED_ATTR: [
                    "href","src","alt","title",
                    "class","style","target","rel"
                  ],
                  ALLOW_DATA_ATTR: false,
                  KEEP_CONTENT: true
                }
              ),
            }}
          />
        </div>

        {/* RIGHT FORM */}
        <div className="single-blog-right">
          <div className="sticky-form">
            <h2 className="form-heading">Get in Touch</h2>

            <form className="contact-form" onSubmit={sendEmail}>
              <input type="text" name="user_name" placeholder="Name" required />
              <input type="email" name="user_email" placeholder="Email" required />
              <input type="tel" name="user_phone" placeholder="Phone" required />
              
              <textarea
                name="user_message"
                placeholder="Message"
                rows="3"
                required
              />

              <input type="hidden" name="page_url" value={currentPageURL} />

              <button type="submit">Submit</button>
            </form>

          </div>
        </div>

      </div>
    </div>
  );
};

export default SingleBlog;
